<template>
    <div>
        <slot></slot>
        <Footer />
    </div>
</template>

<script>
import Footer from '../components/Footer'

export default {
    name: 'Simple',
    components: {
        Footer
    }
}
</script>
